import { render, staticRenderFns } from "./TextSlider.vue?vue&type=template&id=20d937f4&scoped=true&"
import script from "./TextSlider.vue?vue&type=script&lang=js&"
export * from "./TextSlider.vue?vue&type=script&lang=js&"
import style0 from "./TextSlider.vue?vue&type=style&index=0&id=20d937f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d937f4",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/TextSlider.vue
// module id = 254
// module chunks = 0